import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

moment.suppressDeprecationWarnings = true;

@Pipe({ name: 'customDate', standalone: true })
export class CustomDatePipe implements PipeTransform {
  transform(value: any, format: string): string {
    value = value?.split(' ')[0];
    const momentDate = moment(value);
    if (!momentDate.isValid()) {
      return value;
    }
    return momentDate.format(format);
  }
}

@Pipe({
    name: 'phoneNumber',
    standalone: true
})
export class NumberFormatPipe implements PipeTransform {
  transform(phone: string): string {
    if (!phone) {
      return '';
    }
    if (phone.trim().length === 10) {
      return (
        '(' +
        phone.substring(0, 3) +
        ') ' +
        phone.substring(3, 6) +
        '-' +
        phone.substring(6)
      );
    }
    return phone;
  }
}

@Pipe({
    name: 'faxNumber',
    standalone: true
})
export class FaxNumberFormatPipe implements PipeTransform {
  transform(faxNumber: string): string {
    if (!faxNumber) {
      return '';
    }
    if (faxNumber.trim().length === 10) {
      return (
        faxNumber.substring(0, 3) +
        '-' +
        faxNumber.substring(3, 6) +
        '-' +
        faxNumber.substring(6)
      );
    }
    return faxNumber;
  }
}
